document.allShippingRates = [
{
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 13.95,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 27.9,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 41.85,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 55.8,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 69.75,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 83.7,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 97.65,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 111.6,
  Country_code: "BE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 27.95,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 55.9,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 83.85,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 111.8,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 139.75,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 167.7,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 195.65,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 223.6,
  Country_code: "BA",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 24.95,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 49.9,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 74.85,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 99.8,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 124.75,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 149.7,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 174.65,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 199.6,
  Country_code: "BG",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 14.95,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 29.9,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 44.85,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 59.8,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 74.75,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 89.7,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 104.65,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 119.6,
  Country_code: "DK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 13.95,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 27.9,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 41.85,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 55.8,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 69.75,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 83.7,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 97.65,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 111.6,
  Country_code: "DE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 24.95,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 49.9,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 74.85,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 99.8,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 124.75,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 149.7,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 174.65,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 199.6,
  Country_code: "EE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 27.95,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 55.9,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 83.85,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 111.8,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 139.75,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 167.7,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 195.65,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 223.6,
  Country_code: "FI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 15.95,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 31.9,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 47.85,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 63.8,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 79.75,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 95.7,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 111.65,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 127.6,
  Country_code: "FR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 39.95,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 79.9,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 119.85,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 159.8,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 199.75,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 239.7,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 279.65,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 319.6,
  Country_code: "GR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 22.95,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 45.9,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 68.85,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 91.8,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 114.75,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 137.7,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 160.65,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 183.6,
  Country_code: "HU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 22.95,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 45.9,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 68.85,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 91.8,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 114.75,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 137.7,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 160.65,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 183.6,
  Country_code: "IE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 18.95,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 37.9,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 56.85,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 75.8,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 94.75,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 113.7,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 132.65,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 151.6,
  Country_code: "IT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 24.95,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 49.9,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 74.85,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 99.8,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 124.75,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 149.7,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 174.65,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 199.6,
  Country_code: "HR",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 27.95,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 55.9,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 83.85,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 111.8,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 139.75,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 167.7,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 195.65,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 223.6,
  Country_code: "LV",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 22.95,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 45.9,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 68.85,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 91.8,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 114.75,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 137.7,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 160.65,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 183.6,
  Country_code: "LI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 24.95,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 49.9,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 74.85,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 99.8,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 124.75,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 149.7,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 174.65,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 199.6,
  Country_code: "LT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 14.95,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 29.9,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 44.85,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 59.8,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 74.75,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 89.7,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 104.65,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 119.6,
  Country_code: "LU",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 19.95,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 39.9,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 59.85,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 79.8,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 99.75,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 119.7,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 139.65,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 159.6,
  Country_code: "MC",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 12.95,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 25.9,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 38.85,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 51.8,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 64.75,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 77.7,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 90.65,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 103.6,
  Country_code: "NL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 14.95,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 29.9,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 44.85,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 59.8,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 74.75,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 89.7,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 104.65,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 119.6,
  Country_code: "AT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 22.95,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 45.9,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 68.85,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 91.8,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 114.75,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 137.7,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 160.65,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 183.6,
  Country_code: "PL",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 19.95,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 39.9,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 59.85,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 79.8,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 99.75,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 119.7,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 139.65,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 159.6,
  Country_code: "PT",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 29.5,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 59,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 88.5,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 118,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 147.5,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 177,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 206.5,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 236,
  Country_code: "RO",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 39.95,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 79.9,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 119.85,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 159.8,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 199.75,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 239.7,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 279.65,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 319.6,
  Country_code: "RS",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 24.95,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 49.9,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 74.85,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 99.8,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 124.75,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 149.7,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 174.65,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 199.6,
  Country_code: "SI",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 24.95,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 49.9,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 74.85,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 99.8,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 124.75,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 149.7,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 174.65,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 199.6,
  Country_code: "SK",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 18.5,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 37,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 55.5,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 74,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 92.5,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 111,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 129.5,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 148,
  Country_code: "ES",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 22.95,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 45.9,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 68.85,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 91.8,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 114.75,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 137.7,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 160.65,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 183.6,
  Country_code: "CZ",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 0-31.5kg",
  Carrier: "DPD",
  Minimal_weight: .01,
  Maximal_weight: 29,
  Price: 22.95,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 31.5-63kg",
  Carrier: "DPD",
  Minimal_weight: 29.01,
  Maximal_weight: 58,
  Price: 45.9,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 63-94.5kg",
  Carrier: "DPD",
  Minimal_weight: 58.01,
  Maximal_weight: 87,
  Price: 68.85,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 94.5-126kg",
  Carrier: "DPD",
  Minimal_weight: 87.01,
  Maximal_weight: 116,
  Price: 91.8,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 126-157.5kg",
  Carrier: "DPD",
  Minimal_weight: 116.01,
  Maximal_weight: 145,
  Price: 114.75,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 157.5-189kg",
  Carrier: "DPD",
  Minimal_weight: 145.01,
  Maximal_weight: 174,
  Price: 137.7,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 189-220.5kg",
  Carrier: "DPD",
  Minimal_weight: 174.01,
  Maximal_weight: 203,
  Price: 160.65,
  Country_code: "SE",
  Province_code: ""
}, {
  Shipping_method: "DPD Home 220.5-252kg",
  Carrier: "DPD",
  Minimal_weight: 203.01,
  Maximal_weight: 232,
  Price: 183.6,
  Country_code: "SE",
  Province_code: ""
}];
